export default __webpack_public_path__ + "2e9e88aacab999d3c13c52a825fc6f91.png";